import environmentVariables from '../app/environmentVariables';

/**
 * GET `/launch/screens` — public gallery list with listing photos.
 */
export async function getNetworkScreens() {
    const res = await fetch(`${environmentVariables().REACT_APP_API_URL}/launch/screens`);
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success) {
        throw new Error(data.error || 'Failed to load network screens');
    }
    return data;
}
